import api from '../api.js';
import db from '../../versa/db.js';
import crud from '../../versa/crud.js';
import router from '../../versa/router.js';
import { notify, ask } from '../../versa/msgbox.js';
import view from '../views/users.js';
import form from '../forms/users.js';
import * as types from '../types.js';

const LOCKOUT_DAYS = 30;

function lockoutExpirationIso() {
	const d = new Date();
	d.setDate(d.getDate() + LOCKOUT_DAYS);
	return d.toISOString();
}

const users = function()
{

	let users_crud = crud.create({
		async loadBaseData()
		{
			api.call(api.list_groups, this.queryAll()).then((data) => db.set('groups', data).catch(error => notify(error)));
		},
		async queryData(query)
		{
			return await api.call(api.list_users, query);
		},
		async loadRecord(id)
		{
			const data = await api.call(api.select_user, ...JSON.parse(id));
			if (data && typeof data === 'object') {
				data.user_status = data.is_disabled ? 'Inativo' : (data.is_blocked ? 'Bloqueado' : 'Ativo');
			}
			return data;
		},
		async saveRecord(data, old_data)
		{
			let _record = {
				name: data.name,
				email: data.email,
				phone: data.phone,
				username: data.username,
				groups: data.groups,
			};
			if (old_data) {
				// Preservar is_disabled e lockout_expiration do servidor (bloqueio/inativo alterados na ficha)
				const current = await api.call(api.select_user, data.id);
				if (current && typeof current === 'object') {
					if ('is_disabled' in current) _record.is_disabled = current.is_disabled;
					if ('lockout_expiration' in current) _record.lockout_expiration = current.lockout_expiration;
				}
				return await api.call(api.update_user, data.id, _record);
			}
			return await api.call(api.insert_user, _record);
		},
		async setDisabled(disabled) {
			const ids = await this.getSelectedIds(['id']);
			if (!ids.length) return notify('Selecione ao menos um usuário.', 'Usuários');
			const action = disabled ? 'Inativar' : 'Ativar';
			ask(`Confirma ${action} ${ids.length} usuário(s)?`, action, async (answer) => {
				if (answer !== 'Y') return;
				for (const [id] of ids) {
					const resp = await api.call(api.update_user, id, { is_disabled: !!disabled });
					if (resp == null) { notify('Falha ao atualizar usuário.', 'Usuários'); return; }
				}
				this.loadPage();
			});
		},
		async setBlocked(blocked) {
			const ids = await this.getSelectedIds(['id']);
			if (!ids.length) return notify('Selecione ao menos um usuário.', 'Usuários');
			const action = blocked ? 'Bloquear' : 'Desbloquear';
			ask(`Confirma ${action} ${ids.length} usuário(s)?`, action, async (answer) => {
				if (answer !== 'Y') return;
				const payload = blocked ? { lockout_expiration: lockoutExpirationIso() } : { lockout_expiration: null };
				for (const [id] of ids) {
					const resp = await api.call(api.update_user, id, payload);
					if (resp == null) { notify('Falha ao atualizar usuário.', 'Usuários'); return; }
				}
				this.loadPage();
			});
		},
	});
	
	// Index = position in the backend's SELECT
	let fieldspecs = [
		{ index: 1, field: 'id', label: 'Usuário', types: [], placeholder: '', title: 'Identificador do usuário' },
		{ index: 2, field: 'name', label: 'Nome', types: [types.name()], placeholder: '', title: 'Nome do usuário' },
		{ index: 3, field: 'email', label: 'Email', types: [types.email()], placeholder: '', title: 'Email para reset de senha' },
		{ index: 4, field: 'phone', label: 'Fone', types: [types.phone()], placeholder: '+00 (00) 0000-0000', title: 'Telefone de contato' },
		{ index: 5, field: 'username', label: 'Username', types: [types.username()], placeholder: '', title: 'Nome de usuário para acesso ao sistema' },
		{ index: 6, field: 'user_status', label: 'Status', types: [], placeholder: '', title: 'Status do usuário' },
		{ index: 7, field: 'is_blocked', label: 'Bloqueado', types: [], placeholder: '', title: 'Usuário bloqueado (SIM/NAO)' },
	];

	let operations = [
		{ hash: '#user-disable',   label: 'Inativar'      },
		{ hash: '#user-enable',    label: 'Ativar'        },
		{ hash: '#user-block',     label: 'Bloquear'      },
		{ hash: '#user-unblock',   label: 'Desbloquear'    },
	];

	router.set('#user-disable',  users_crud.setDisabled.bind(users_crud, true));
	router.set('#user-enable',   users_crud.setDisabled.bind(users_crud, false));
	router.set('#user-block',    users_crud.setBlocked.bind(users_crud, true));
	router.set('#user-unblock',  users_crud.setBlocked.bind(users_crud, false));

	users_crud.run(
		'users',
		'Usuários',
		document.getElementById('workarea'),
		view,
		form,
		fieldspecs,
		operations,
		[]
	);

};

export default users;

